export default "__VITE_ASSET__D1qPt8f4__"